import * as yup from 'yup';
import { schemaMap } from './schemaMap';
import { maybeAddOptionalityToSchema } from './maybeAddOptionalityToSchema';
import { getInitialVariableValue } from './getInitialVariableValue';
import { removeEmptyConditions } from './removeEmptyConditions';

export const getSchema = (template, allOptional = false) =>
  yup.object(
    (template.document.data.variables || []).reduce(
      (prev, variable, i, allVariables) => {
        if (variable.type === 'conditional') {
          return prev;
        }

        let value = schemaMap[variable.type];

        if (
          ['integer', 'money'].includes(variable.type) &&
          !['', null, undefined].includes(variable.minValue)
        ) {
          value = value.min(variable.minValue, {
            locKey: 'common:formErrors.minValue',
            locVal: { min: variable.minValue },
          });
        }

        if (
          ['integer', 'money'].includes(variable.type) &&
          !['', null, undefined].includes(variable.maxValue)
        ) {
          value = value.max(variable.maxValue, {
            locKey: 'common:formErrors.maxValue',
            locVal: { max: variable.maxValue },
          });
        }

        if (['integer', 'money'].includes(variable.type) && variable.required) {
          value = value.test(
            'is-required',
            'common:formErrors.required',
            value => value !== null,
          );
        }

        if (variable.type === 'select' || variable.type === 'tabs') {
          value = value.oneOf([
            ...variable.options.map(v => v.value),
            null,
            '',
          ]);
        }

        const initialValue = getInitialVariableValue(variable);

        let variableSchema;

        if (variable.list && removeEmptyConditions(variable.requiredWhen)) {
          const varsKeys = allVariables
            .filter(v => !removeEmptyConditions(v.requiredWhen))
            .map(v => v.name);

          variableSchema = yup
            .array()
            .when(varsKeys, (varsValues, schema) => {
              return schema.optional();

              /**
               * @see https://pergamin.atlassian.net/browse/PERG-2398
               * Validation "required when" in loop is broken by data structure and is impossible or very hard to fix.
               */
              // return schema.of(
              //   maybeAddOptionalityToSchema(
              //     value,
              //     variable,
              //     allVariables,
              //     allOptional,
              //     varsValues,
              //   ),
              // );
            })
            .default([initialValue, initialValue]);
        } else if (variable.list) {
          variableSchema = yup
            .array(
              maybeAddOptionalityToSchema(
                value,
                variable,
                allVariables,
                allOptional,
              ),
            )
            .default([initialValue, initialValue]);
        } else if (variable.type === 'dynamicList') {
          variableSchema = maybeAddOptionalityToSchema(
            value,
            variable,
            allVariables,
            allOptional,
          ).default(initialValue);
        } else {
          if (variable.regExp) {
            const regex = new RegExp(variable.regExp);

            value = value.test(
              'regExp',
              {
                locKey: 'common:formErrors.regExp',
                locVal: { regex: variable.regExp },
              },
              v => (v ? regex.test(v) : true),
            );
          }

          variableSchema = maybeAddOptionalityToSchema(
            value,
            variable,
            allVariables,
            allOptional,
          ).default(initialValue);
        }

        return {
          ...prev,
          [variable.name]: variableSchema,
        };
      },
      {},
    ),
  );
